var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('div',{staticClass:"configurator-bike-picture mt-4 mb-4"},[_c('v-lazy-image',{attrs:{"src":_vm.url}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }